import { render } from "./KskStepper.vue?vue&type=template&id=56a0260e&scoped=true"
import script from "./KskStepper.vue?vue&type=script&lang=js"
export * from "./KskStepper.vue?vue&type=script&lang=js"

import "./KskStepper.vue?vue&type=style&index=0&id=56a0260e&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a0260e"]])

export default __exports__